import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { projects } from '../content/projects';

const defaultDescription = 'Product engineering leadership across web, mobile, real-time media, UX, and creative technology by Charles Van Alst Danner.';

const routeMetadata = {
  '/': {
    title: 'Charles Van Alst Danner | Product Engineering Leader',
    description: 'Product engineering leader with 10+ years of experience building web, mobile, and real-time media products.',
  },
  '/work': {
    title: 'Selected Work | Charles Van Alst Danner',
    description: 'Selected product, interface, and systems case studies by Charles Van Alst Danner.',
  },
  '/art': { title: 'Art | Charles Van Alst Danner', description: 'Selected performances, sound work, installations, and emerging-media artwork.' },
  '/lab': { title: 'Lab | Charles Van Alst Danner', description: 'Prototypes, technical sketches, creative experiments, and concept development.' },
  '/lab/news-pipeline': {
    title: 'Fake News | Charles Van Alst Danner',
    description: 'An autonomous, multi-agent synthetic news broadcast system spanning source validation, editorial orchestration, multi-voice TTS, GPU workers, and FFmpeg assembly.',
  },
  '/ascii-tv': { title: 'ASCII-TV | Interactive Browser Installation', description: 'A browser-based television time capsule that transforms period broadcasts into a living ASCII transmission.' },
  '/about': { title: 'About | Charles Van Alst Danner', description: defaultDescription },
  '/bio': { title: 'About | Charles Van Alst Danner', description: defaultDescription },
  '/resume': { title: 'Resume | Charles Van Alst Danner', description: 'Experience and selected work across frontend engineering, product design, audio, and creative technology.' },
  '/contact': { title: 'Contact | Charles Van Alst Danner', description: 'Contact Charles Van Alst Danner about frontend, product, media-technology, and creative-technology opportunities.' },
};

projects.forEach((project) => {
  routeMetadata[project.path] = { title: `${project.title} | Charles Van Alst Danner`, description: project.summary };
});

function RouteMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = routeMetadata[pathname] || {
      title: 'Page Not Found | Charles Van Alst Danner',
      description: defaultDescription,
    };
    document.title = metadata.title;
    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }
    description.setAttribute('content', metadata.description);
  }, [pathname]);

  return null;
}

export default RouteMetadata;
